import { FeaturedOfferShingleReseal } from "pages/overview/featured-offers/featured-offer-shingle-reseal";
import { type KeystoneOfferEligibility } from "utils/keystone-api-mapping";

import { FeaturedOfferTing } from "./featured-offer-ting";

type FeaturedOffersProps = {
  offers: KeystoneOfferEligibility[];
};

export const FeaturedOffers = ({ offers }: FeaturedOffersProps) => {
  const tingOffer = offers.find(
    (offer) => offer.offeringInternalName === "ting-offer"
  );
  const shingleResealOffer = offers.find(
    (offer) => offer.offeringInternalName === "wind-defense"
  );
  if (tingOffer) {
    return <FeaturedOfferTing />;
  } else if (shingleResealOffer) {
    return <FeaturedOfferShingleReseal />;
  } else {
    return null;
  }
};
